import { Routes } from '@angular/router';
import {
  AuthGuard,
  adminGuard,
  changePasswordGuard,
  companyGuard,
  superAdminGuard,
  guestGuard,
} from './core/guards/auth.guard';
import {
  PATH_CHANGE_PASSWORD,
  PATH_EMPRESAS,
  PATH_LANDING,
  PATH_LANDING_FIXED,
  PATH_LOGIN,
} from '../routes/routes.constants';

export const routes: Routes = [
  {
    path: PATH_LANDING,
    loadComponent: () =>
      import('./features/landing/landing.component').then(
        (m) => m.LandingComponent,
      ),
  },
  {
    path: PATH_LANDING_FIXED,
    loadComponent: () =>
      import('./features/landing-fixed/landing-fixed.component').then(
        (m) => m.LandingFixedComponent,
      ),
  },
  // [SSO deshabilitado] Retorno del SSO de Fidel. Reactivar junto con Auth:SsoEnabled en la API:
  // { path: PATH_SSO_CALLBACK, component: SsoCallbackComponent },
  {
    path: PATH_LOGIN,
    canActivate: [guestGuard],
    loadComponent: () =>
      import('./features/auth/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: PATH_CHANGE_PASSWORD,
    canActivate: [changePasswordGuard],
    loadComponent: () =>
      import('./features/auth/change-password/change-password.component').then(
        (m) => m.ChangePasswordComponent,
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./features/dashboard/dashboard-shell/shell.component').then(
        (m) => m.ShellComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: 'overlay-text',
        canActivate: [companyGuard],
        loadComponent: () =>
          import('./features/overlay-text/overlay-text.component').then(
            (m) => m.OverlayTextComponent,
          ),
        loadChildren: () =>
          import('./features/overlay-text/overlay-text.routes').then(
            (m) => m.OVERLAY_TEXT_ROUTES,
          ),
      },
      {
        path: 'video-wall',
        canActivate: [companyGuard],
        loadComponent: () =>
          import('./features/video-wall/video-wall-list.component').then(
            (m) => m.VideoWallListComponent,
          ),
      },
      {
        path: 'editor',
        canActivate: [companyGuard],
        loadComponent: () =>
          import('./features/editor/video-editor.component').then(
            (m) => m.VideoEditorComponent,
          ),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        canActivate: [companyGuard],
        loadComponent: () =>
          import('./features/dashboard/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
      },
      {
        path: 'devices',
        canActivate: [companyGuard],
        loadComponent: () =>
          import('./features/devices/device-list.component').then(
            (m) => m.DeviceListComponent,
          ),
      },
      {
        path: 'register-devices',
        canActivate: [companyGuard],
        loadComponent: () =>
          import('./features/devices/registration-wizard/device-registration-wizard.component').then(
            (m) => m.DeviceRegistrationWizardComponent,
          ),
      },
      {
        path: 'media',
        loadComponent: () =>
          import('./features/media/media-library.component').then(
            (m) => m.MediaLibraryComponent,
          ),
      },
      {
        path: 'playlists',
        canActivate: [companyGuard],
        loadComponent: () =>
          import('./features/playlist/playlist-shell/playlist-shell.component').then(
            (m) => m.PlaylistShellComponent,
          ),
      },
      {
        path: PATH_EMPRESAS,
        canActivate: [superAdminGuard],
        loadComponent: () =>
          import('./features/empresas/empresa-management.component').then(
            (m) => m.EmpresaManagementComponent,
          ),
      },
      {
        path: 'users',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/users/user.component').then(
            (m) => m.UserComponent,
          ),
      },
      {
        path: 'sucursales',
        canActivate: [companyGuard],
        loadComponent: () =>
          import('./features/sucursales/sucursal-management.component').then(
            (m) => m.SucursalManagementComponent,
          ),
      },
      {
        path: 'variantes',
        canActivate: [companyGuard],
        loadComponent: () =>
          import('./features/flavors/flavor-management.component').then(
            (m) => m.FlavorManagementComponent,
          ),
      },
      {
        path: 'categorias',
        canActivate: [companyGuard],
        loadComponent: () =>
          import('./features/categories/category-management.component').then(
            (m) => m.CategoryManagementComponent,
          ),
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./features/not-found/not-found.component').then(
        (m) => m.NotFoundComponent,
      ),
  },
];
